import React, { Component } from 'react';
import { Link } from 'react-router';
import { Button, Form, Input, Table } from 'antd';
import UploadFile from '@comm/upload/UploadFileTable';

const FormItem = Form.Item;

class TableFiles extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  columns = () => {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    return [
      {
        title: '文件名称',
        dataIndex: 'name',
        key: 'name',
        width: '30%',
        render: (text, record) => {
          const filesArr = getFieldValue(`files${record.id}`) || [];
          let defaultName = filesArr[0] ? filesArr[0].name : '';
          const index = defaultName.indexOf('.');
          defaultName = defaultName.slice(0, index);
          return (
            <FormItem style={{ margin: 0, height: '60px' }}>
              {getFieldDecorator(`name${record.id}`, {
                initialValue: record.name || defaultName || null,
              })(<Input placeholder="请输入文件名称" />)}
            </FormItem>
          );
        },
      },
      {
        title: '附件',
        dataIndex: 'files',
        key: 'files',
        width: '50%',
        render: (text, record) => {
          return (
            <FormItem>
              {getFieldDecorator(`files${record.id}`, {
                initialValue: record.files || [],
              })(
                <UploadFile
                  type="ghost"
                  fileList={record.file}
                  isPreview
                  onRemove={this.props.fileRemove}
                />,
              )}
            </FormItem>
          );
        },
      },
      {
        title: '操作',
        dataIndex: 'done',
        key: 'done',
        render: (text, record) => {
          return (
            <div style={{ margin: 0, height: '45px' }}>
              <Link onClick={this.props.deleteFiles(record.id)}>删除</Link>
            </div>
          );
        },
      },
    ];
  };

  render() {
    const { fileList } = this.props;
    return (
      <div>
        <Table columns={this.columns()} dataSource={fileList} pagination={false} rowKey="id" />
        <Button onClick={this.props.addFiles} style={{ width: '100%', borderStyle: 'dashed' }}>
          +添加附件
        </Button>
      </div>
    );
  }
}

export default TableFiles;



// WEBPACK FOOTER //
// ./src/components/task/spTask/TableFilesAddDel.js